export const useTresholdName = (tresholds: any[], id: number) => {
    return tresholds.find((t: any) => t.id == id)?.label ?? ''
}
